import { Check } from 'lucide-react';
import type { LiksDropdownOption } from './LiksDropdown.types';

export type LiksDropdownOptionRowProps = {
  option: LiksDropdownOption;
  optionId: string;
  isSelected: boolean;
  isActive: boolean;
  onMouseEnter: () => void;
  onClick: () => void;
  optionRef: (element: HTMLDivElement | null) => void;
};

export function LiksDropdownOptionRow({
  option,
  optionId,
  isSelected,
  isActive,
  onMouseEnter,
  onClick,
  optionRef,
}: LiksDropdownOptionRowProps) {
  return (
    <div
      ref={optionRef}
      id={optionId}
      className={[
        'liks-dropdown__option',
        isActive && 'liks-dropdown__option--active',
        isSelected && 'liks-dropdown__option--selected',
      ]
        .filter(Boolean)
        .join(' ')}
      role="option"
      aria-selected={isSelected}
      onMouseEnter={onMouseEnter}
      onClick={onClick}
    >
      <span
        className={[
          'liks-dropdown__option-check',
          isSelected && 'liks-dropdown__option-check--checked',
        ]
          .filter(Boolean)
          .join(' ')}
        aria-hidden
      >
        {isSelected && (
          <Check className="liks-dropdown__option-check-icon" strokeWidth={3} />
        )}
      </span>
      <span className="liks-dropdown__option-label">{option.label}</span>
    </div>
  );
}
